import loadable from '@loadable/component'
import { prop } from 'ramda'
import { asyncConnect } from 'redux-connect'

import { getFilters } from 'pages/Notifications/helpers'
import parse from 'utils/querystring'

const Notifications = loadable(() => import(/* webpackChunkName: "Notifications" */'pages/Notifications/Notifications'))

export default asyncConnect([
  {
    key: 'pageNotifications',
    promise: ({ helpers: { updateData }, location }) => {
      const query = parse(prop('search', location))
      const { page, limit, offset, sort, order, filter } = getFilters(query)
      
      updateData.set({
        view: 'notifications',
        page,
        limit,
        offset,
        sort,
        order,
        filter
      })
      return updateData.update()
    }
  }
])(Notifications)
